(() => {
  angular
    .module('gm.common.filters')
    .filter('gmShowLast', gmShowLastFilter);

  function gmShowLastFilter() {
    'ngInject';

    return (val, show = 4) => `${val}`.slice(-1 * show);
  }
})();
